export default "__VITE_PUBLIC_ASSET__0a2b5b51__"